import { useEffect } from "react";

export default function SEO({ title, description, keywords }) {
  useEffect(() => {
    if (title) document.title = title;
    const setMeta = (name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[name="${name}"]`);
      if (!el) { el = document.createElement("meta"); el.name = name; document.head.appendChild(el); }
      el.content = content;
    };
    setMeta("description", description);
    setMeta("keywords", keywords);
    return () => { document.title = "CSR Associates | Debt Recovery & BPO Services Bangalore"; };
  }, [title, description, keywords]);
  return null;
}
